module.exports = __webpack_public_path__ + "assets/img/title-5c69ec57.png";